import { Action } from 'redux';

import { isEnterContentSpaceAction } from '../actions/spaces/EnterSpaceAction';
import { ContainerInfoState } from '../state/ContainerInfoState';

const defaultContainertInfo: ContainerInfoState = {
    type: ''
};

export function containerInfoReducer(previousState: ContainerInfoState = defaultContainertInfo, action: Action): ContainerInfoState {
    if(isEnterContentSpaceAction(action)) {
        return ({
            type: action.contentSpaceInfo.contentLocation
        });
    }

    return previousState;
}